import TipoPerfilAcesso from "../../../models/usuarios/tipo-perfil-acesso"

export const perfilPermissaoCancelamentoForcado = [
    TipoPerfilAcesso.Administrador,
    TipoPerfilAcesso.Gestor,
    TipoPerfilAcesso.MasterData,
    TipoPerfilAcesso.PciSolutions
]
